var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconionicMdPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.665,
    height: 27.531,
    viewBox: "0 0 19.665 27.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-pin",
    "data-name": "Icon ionic-md-pin",
    d: "M16.583,2.25A9.764,9.764,0,0,0,6.75,11.886c0,7.227,9.833,17.9,9.833,17.9s9.833-10.668,9.833-17.9A9.764,9.764,0,0,0,16.583,2.25Zm0,13.077a3.442,3.442,0,1,1,3.512-3.441A3.444,3.444,0,0,1,16.583,15.327Z",
    transform: "translate(-6.75 -2.25)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicMdPin);
export default __webpack_public_path__ + "static/media/Icon ionic-md-pin.194bc41fb46ecc30609578860813e7cc.svg";
export { ForwardRef as ReactComponent };